import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      [theme.breakpoints.down('sm')]: {
        marginTop: 10,
      },
      [theme.breakpoints.down('xs')]: {
        marginTop: 5,
      },
      marginBottom: -10,
      position: 'fixed',
      bottom: 0,
      maxWidth: 680,
      width: '100%',
      padding: '0px!important',
    },
    box: {
      boxShadow:
        '0px 0px 10px 0px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)!important',
      margin: '0!important',
      borderTopRightRadius: '25px!important',
      borderTopLeftRadius: '25px!important',
      alignItems: 'center',
    },
    iconHome: {
      width: 20,
      height: 20,
      marginRight: 10,
    },
    iconPromotion: {
      width: 20,
      marginRight: 4,
      height: 20,
    },
    iconRequest: {
      width: 20,
      marginRight: 10,
      height: 20,
    },
    textBtn: {
      [theme.breakpoints.down(370)]: {
        fontSize: '0.7rem',
      },
      [theme.breakpoints.down(350)]: {
        fontSize: '0.6rem',
      },
      [theme.breakpoints.down(330)]: {
        fontSize: '0.5rem',
      },
      fontSize: '0.8rem',
      textTransform: 'none',
      color: '#4c4f53',
    },
    textBtnBold: {
      fontSize: 13,
      textTransform: 'none',
      fontWeight: 550,
      color: '#a51713',
    },
    textBtnNotification: {
      backgroundColor: '#bd1616',
      width: 18,
      height: 18,
      fontSize: 10,
      borderRadius: 18,
      marginTop: -5,
      color: '#fff',
    },
    houveBtn: {
      backgroundColor: '#fddcdb!important',
      borderRadius: '25px!important',
      padding: '0 8px!important',
      height: '35px!important',
    },
    btnSubmit: {
      margin: '0px 0!important',
      textTransform: 'uppercase',
      backgroundColor: '#a51713!important',
      width: '100%',
      borderRadius: '10px!important',
    },
  }),
);

export default useStyles;
